export const environment = {
	production: false,
	LOGIN_API_URL: "https://jngpu7xkri.execute-api.ap-south-1.amazonaws.com/dev/",
	API_URL: "https://771y4duuj3.execute-api.ap-south-1.amazonaws.com/dev/",
	File_Storage_URL: "https://backend-content-storage.s3.ap-south-1.amazonaws.com/",
	version: "1.0.1"
};